import React from 'react';
import { RecommendedApps } from './recommended-apps';
import { EmptyStateDivider } from './empty-state-divider';
import { AddAppBox } from './add-app-box';
import s from './empty-state.scss';
import { Origin, EditorType } from '../manage-installed-apps-page';
import { Button, Page } from '@wix/design-system';
import { useExperiments } from '@wix/wix-experiments-react';
import { manageAppsAddApp } from '@wix/bi-logger-app-market-data/v2';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useTranslation } from '../../hooks/use-translation';
export function EmptyState({ baseUrl, msid, locale, gotoWebSolutionPage, goToHomePage, origin, editorType, httpClient, isEditorless, }) {
    const t = useTranslation();
    const biLogger = useBiLogger();
    const { experiments } = useExperiments();
    const title = experiments.enabled('specs.appMarket.manageAppsTextTest')
        ? t('manage-apps.page.title.test')
        : t('manage-apps.page.title');
    const buttonText = origin === Origin.DAYFUL
        ? 'manage-apps.empty-state.go-to-dayful-market'
        : isEditorless
            ? 'manage-apps.empty-state.go-to-editorless-market'
            : 'manage-apps.empty-state.go-to-app-market';
    return (React.createElement(Page, { height: "100%" },
        React.createElement(Page.Header, { title: title, className: s.emptyStateTitle, actionsBar: React.createElement(Button, { onClick: () => {
                    biLogger
                        .report(manageAppsAddApp({
                        market: origin === Origin.BIZMGR
                            ? editorType === EditorType.ADI
                                ? 'adi_dashboard'
                                : 'dashboard'
                            : origin,
                        msid,
                        referral_info: 'manage_apps',
                    }))
                        .catch((e) => console.log(e));
                    goToHomePage();
                } }, t(buttonText)) }),
        React.createElement(Page.Content, null,
            React.createElement(AddAppBox, { isEditorless: isEditorless, origin: origin, msid: msid, goToHomePage: goToHomePage, editorType: editorType }),
            origin !== Origin.DAYFUL && !isEditorless ? (React.createElement(React.Fragment, null,
                React.createElement(EmptyStateDivider, null),
                React.createElement(RecommendedApps, { baseUrl: baseUrl, httpClient: httpClient, locale: locale, origin: origin, gotoWebSolutionPage: gotoWebSolutionPage, editorType: editorType, msid: msid }))) : null)));
}
//# sourceMappingURL=empty-state.js.map